import NoticeApi from '@apis/notice/NoticeApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetNoticesParams } from '@models/notice';

const noticeQueries = createQueryKeys('notice', {
  list: (params: GetNoticesParams) => ({
    queryKey: [params],
    queryFn: () => NoticeApi.getNotices(params),
  }),
  detail: (noticeId: string) => ({
    queryKey: [noticeId],
    queryFn: () => NoticeApi.getNotice(noticeId),
  }),
});

export default noticeQueries;
